(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Secondary-Navigation"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;

      this.onScrollHandler = this.onScroll.bind(this);

      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["csl-performance-header"]) return;
  try {
    
  if (!customElements.get('csl-performance-header')) {
    customElements.define('csl-performance-header', class extends HTMLElement {
      connectedCallback() {
        this.onToggle = event => {
          const item = event.target;
          if (item.matches('.csl-header__category') && item.open) {
            this.querySelectorAll('.csl-header__category').forEach(other => { if (other !== item) other.open = false; });
          }
        };
        this.onOutside = event => { if (!this.contains(event.target)) this.closeAll(); };
        this.onEscape = event => {
          if (event.key !== 'Escape') return;
          const open = event.target.closest('details[open]');
          if (open) { open.open = false; open.querySelector('summary').focus(); }
          else this.closeAll();
        };
        this.hoverQuery = window.matchMedia('(min-width: 1200px) and (hover: hover) and (pointer: fine)');
        this.onPointerOver = event => {
          if (!this.hoverQuery.matches || event.pointerType === 'touch') return;
          const item = event.target.closest('.csl-header__desktop-menu .csl-header__category');
          if (!item || item.contains(event.relatedTarget)) return;
          clearTimeout(this.hoverCloseTimer);
          this.querySelectorAll('.csl-header__desktop-menu .csl-header__category').forEach(other => { if (other !== item) other.open = false; });
          item.open = true;
        };
        this.onPointerOut = event => {
          if (!this.hoverQuery.matches || event.pointerType === 'touch') return;
          const item = event.target.closest('.csl-header__desktop-menu .csl-header__category');
          if (!item || item.contains(event.relatedTarget)) return;
          clearTimeout(this.hoverCloseTimer);
          this.hoverCloseTimer = setTimeout(() => { if (!item.contains(document.activeElement)) item.open = false; }, 180);
        };
        this.addEventListener('pointerover', this.onPointerOver);
        this.addEventListener('pointerout', this.onPointerOut);
        this.addEventListener('toggle', this.onToggle, true);
        this.addEventListener('keydown', this.onEscape);
        document.addEventListener('click', this.onOutside);
      }
      closeAll() { this.querySelectorAll('details[open]').forEach(item => { item.open = false; }); }
      disconnectedCallback() {
        clearTimeout(this.hoverCloseTimer);
        this.removeEventListener('pointerover', this.onPointerOver);
        this.removeEventListener('pointerout', this.onPointerOut);
        this.removeEventListener('toggle', this.onToggle, true);
        this.removeEventListener('keydown', this.onEscape);
        document.removeEventListener('click', this.onOutside);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["csl-photo-hero"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('csl-photo-hero'))customElements.define('csl-photo-hero',class extends HTMLElement{
connectedCallback(){this.slides=[...this.querySelectorAll('.csl-photo-slide')];this.index=0;this.paused=matchMedia('(prefers-reduced-motion: reduce)').matches;this.pauseButton=this.querySelector('[data-pause]');this.show=i=>{this.index=(i+this.slides.length)%this.slides.length;this.slides.forEach((slide,n)=>slide.hidden=n!==this.index);this.querySelector('[data-count]').textContent=`${this.index+1} / ${this.slides.length}`;};this.update=()=>{this.pauseButton.textContent=this.paused?'▶':'Ⅱ';this.pauseButton.setAttribute('aria-label',this.paused?'Play slideshow':'Pause slideshow');};this.click=e=>{if(e.target.closest('[data-prev]'))this.show(this.index-1);if(e.target.closest('[data-next]'))this.show(this.index+1);if(e.target.closest('[data-pause]')){this.paused=!this.paused;this.update();}};this.addEventListener('click',this.click);this.timer=setInterval(()=>{if(!this.paused&&!document.hidden&&!this.contains(document.activeElement))this.show(this.index+1);},3000);this.update();}
disconnectedCallback(){clearInterval(this.timer);this.removeEventListener('click',this.click);}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["csl-rotating-banner"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('csl-rotating-banner')) {
    customElements.define('csl-rotating-banner', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('.csl-banner__slide')];
        this.index = 0;
        this.manualPause = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.hovered = false;
        this.setAttribute('data-enhanced', '');
        if (this.slides.length < 2) return;
        this.querySelectorAll('button').forEach(button => { button.hidden = false; });
        this.pauseButton = this.querySelector('[data-pause]');
        this.onClick = event => {
          const button = event.target.closest('button');
          if (!button) return;
          if (button.hasAttribute('data-pause')) { this.manualPause = !this.manualPause; this.updatePause(); }
          else this.show(this.index + Number(button.dataset.direction));
          this.schedule();
        };
        this.onEnter = () => { this.hovered = true; this.schedule(); };
        this.onLeave = () => { this.hovered = false; this.schedule(); };
        this.onFocus = () => this.schedule();
        this.onBlur = () => { queueMicrotask(() => this.schedule()); };
        this.onVisibility = () => this.schedule();
        this.onBlock = event => {
          const index = this.slides.findIndex(slide => slide.contains(event.target) || slide === event.target);
          if (index >= 0) { this.manualPause = true; this.show(index); this.updatePause(); this.schedule(); }
        };
        this.addEventListener('click', this.onClick);
        this.addEventListener('mouseenter', this.onEnter);
        this.addEventListener('mouseleave', this.onLeave);
        this.addEventListener('focusin', this.onFocus);
        this.addEventListener('focusout', this.onBlur);
        this.addEventListener('shopify:block:select', this.onBlock);
        document.addEventListener('visibilitychange', this.onVisibility);
        this.updatePause();
        this.schedule();
      }
      show(index) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
      }
      updatePause() {
        this.pauseButton.setAttribute('aria-label', this.manualPause ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel);
        this.pauseButton.querySelector('span').textContent = this.manualPause ? '▶' : 'Ⅱ';
      }
      schedule() {
        clearTimeout(this.timer);
        if (this.manualPause || this.hovered || this.contains(document.activeElement) || document.hidden || this.slides.length < 2) return;
        this.timer = setTimeout(() => { this.show(this.index + 1); this.schedule(); }, Number(this.dataset.interval) || 5000);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('mouseenter', this.onEnter);
        this.removeEventListener('mouseleave', this.onLeave);
        this.removeEventListener('focusin', this.onFocus);
        this.removeEventListener('focusout', this.onBlur);
        this.removeEventListener('shopify:block:select', this.onBlock);
        document.removeEventListener('visibilitychange', this.onVisibility);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["csl-storefront"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('csl-brand-carousel')) {
  customElements.define('csl-brand-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.csl-brand-track');
      this.originals = [...this.track.children];
      this.direction = 1;
      this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.hovered = false;
      this.visible = false;
      this.position = this.track.scrollLeft;
      this.pauseButton = this.querySelector('[data-brand-pause]');
      this.update = () => {
        this.cycle = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        this.pauseButton.textContent = this.paused ? '▶' : 'Ⅱ';
        this.pauseButton.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      };
      this.move = event => {
        if (event.target.closest('[data-brand-pause]')) {
          this.paused = !this.paused;
          this.update();
        }
        const button = event.target.closest('[data-direction]');
        if (!button || !this.cycle) return;
        this.manualUntil = performance.now() + 1400;
        if (Number(button.dataset.direction) < 0 && this.track.scrollLeft < 1) this.track.scrollLeft = this.cycle;
        this.track.scrollBy({left: Number(button.dataset.direction) * this.track.clientWidth * .8, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      this.enter = event => { if (event.pointerType === 'mouse') this.hovered = true; };
      this.leave = () => { this.hovered = false; };
      this.manual = () => { this.manualUntil = performance.now() + 1600; };
      this.addEventListener('click', this.move);
      this.addEventListener('pointerenter', this.enter);
      this.addEventListener('pointerleave', this.leave);
      this.track.addEventListener('pointerdown', this.manual, {passive:true});
      this.track.addEventListener('wheel', this.manual, {passive:true});
      this.track.addEventListener('keydown', this.manual);
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
      this.visibilityObserver = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; });
      this.visibilityObserver.observe(this);
      this.tick = time => {
        const elapsed = this.lastTime ? Math.min(time - this.lastTime, 64) : 0;
        this.lastTime = time;
        if (!this.paused && !this.hovered && this.visible && !document.hidden && !this.contains(document.activeElement) && time > (this.manualUntil || 0) && this.cycle) {
          this.position += elapsed * .028 * this.direction;
          if(this.position >= this.cycle){this.position = this.cycle;this.direction = -1;}
          if(this.position <= 0){this.position = 0;this.direction = 1;}
          this.track.scrollLeft = this.position;
        } else {
          this.position = this.track.scrollLeft;
        }
        this.frame = requestAnimationFrame(this.tick);
      };
      this.update();
      this.frame = requestAnimationFrame(this.tick);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.removeEventListener('click', this.move);
      this.removeEventListener('pointerenter', this.enter);
      this.removeEventListener('pointerleave', this.leave);
      this.track.removeEventListener('pointerdown', this.manual);
      this.track.removeEventListener('wheel', this.manual);
      this.track.removeEventListener('keydown', this.manual);
      this.observer.disconnect();
      this.visibilityObserver.disconnect();

    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      
      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;

      this.onScrollHandler = this.onScroll.bind(this);

      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
